import { FloatingNav } from '@components/ui/FloatingNav';
import { NAV_PAGES } from '@constants/index';

export default function HomeLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <FloatingNav navItems={NAV_PAGES} />
      <main className="relative flex justify-center items-center flex-col overflow-hidden mx-auto sm:px-10 dark:bg-black-100">
        {children}
      </main>
    </>
  );
}
